module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "settings",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("设置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.formrules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-230",
    attrs: {
      "size": "small",
      "type": "text",
      "disabled": !_vm.state2
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), (_vm.state2) ? _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.commit
    }
  }, [(_vm.loading1) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("确认")])]) : _c('div', {
    staticClass: "edit",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 我们会在次日早上7点，把上一天的交易记录发送给您。")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "每日发送交易报表",
      "prop": "status"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-color": "#7ed321",
      "off-color": "#d8d8d8",
      "on-value": "1",
      "off-value": "0",
      "disabled": _vm.state1
    },
    on: {
      "change": _vm.sendChange
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1)], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("邮箱设置")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-595c4035"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/settings.vue
// module id = 831
// module chunks = 0